module.exports = __webpack_public_path__ + "static/media/neutral.b33e6587.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/smileys/neutral.svg
// module id = 1312
// module chunks = 0